import { daKauflandFontFamily } from '../fonts';

const daKauflandTypography = {
  // h0: {},
  // h1: {},
  h2: {
    fontFamily: daKauflandFontFamily,
    fontSize: '1.75rem',
    fontWeight: 600,
    lineHeight: '2.375rem',
  },
  h3: {
    fontFamily: daKauflandFontFamily,
    fontSize: '1.313rem',
    fontWeight: 600,
    lineHeight: '1.75rem ',
  },
  h4: {
    fontFamily: daKauflandFontFamily,
    fontSize: '1rem',
    fontWeight: 600,
    lineHeight: '1.375rem',
  },
  h5: {},
  button: {
    fontFamily: daKauflandFontFamily,
    fontSize: '1rem',
    fontWeight: 400,
    lineHeight: '1rem',
    textTransform: 'none',
  },
  p4: {
    fontFamily: daKauflandFontFamily,
    fontSize: '1rem',
    fontWeight: 400,
    lineHeight: '1.375rem',
  },
  p5: {
    fontFamily: daKauflandFontFamily,
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: '1.313rem',
  },
  p6: {
    fontFamily: daKauflandFontFamily,
    fontSize: '0.813rem',
    fontWeight: 400,
    lineHeight: '1.25rem',
  },
};

export default daKauflandTypography;
